import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, updateProfile } from "firebase/auth";
import { auth } from "../firebase/config";
import { prepararUsuarioNovo } from "./financeService";

export async function cadastrarUsuario({ nome, email, senha }) {
  const cred = await createUserWithEmailAndPassword(auth, email, senha);

  if (nome) {
    await updateProfile(cred.user, { displayName: nome });
  }

  await prepararUsuarioNovo(cred.user.uid, nome || "Meu negócio");
  return cred.user;
}

export async function entrarUsuario({ email, senha }) {
  const cred = await signInWithEmailAndPassword(auth, email, senha);
  return cred.user;
}

export async function sairUsuario() {
  await signOut(auth);
}
